import {
  QAndARoles,
  QuestionStatus,
} from 'router/subrouters/DataRoom/models/QAndA';
import {
  isBuyManageRole,
  isQABuyDrafter,
  isQuestionAnswerApproved,
  isQuestionDrafted,
  isQuestionRejected,
} from 'router/subrouters/DataRoom/utils';

export type ManageActionKeys = 'edit' | 'manage' | 'preview' | 'else';

//this should include every state thats incluced in IN_REVIEW_QUERY_BUY_SIDE query
export const generateManageKey = (
  status: QuestionStatus,
  qaRole: QAndARoles,
): ManageActionKeys => {
  if (isQuestionAnswerApproved(status)) return 'preview';
  if (
    isQABuyDrafter(qaRole) &&
    (isQuestionDrafted(status) || isQuestionRejected(status))
  )
    return 'edit';
  if (!isBuyManageRole(qaRole)) return 'else';
  if (isQuestionRejected(status)) return 'edit';
  if (isQuestionDrafted(status)) return 'manage';
  return 'else';
};
